// extracted by mini-css-extract-plugin
export default {"container":"Styles_container__EHS4l","tagsContainer":"Styles_tagsContainer__1XSLu","clearIcon":"Styles_clearIcon__G1YAA","popover":"Styles_popover__XjKzh"};